var render = function render(){var _vm=this,_c=_vm._self._c;return _c('case-notes-list',{attrs:{"stage":"Demand Prep"}})
}
var staticRenderFns = []

export { render, staticRenderFns }